<template>
<kt-row v-if="status == 'setFormData'">
    <psp-select-modal v-if="dedicated.can_set_psp" :dedicated="dedicated"></psp-select-modal>
    <kt-col xs="12">
        <form @submit.prevent="edit" id="settings_form">
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                    <div class="custom-control custom-checkbox" id="reports_setting-div">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="reports_setting"
                            name="reports_setting"
                            v-model="dedicated.show_psp_report_to_user"
                        >
                        <label class="custom-control-label" id="reports_setting_label" for="reports_setting">
                            {{ $t('label.showPSPReportToUser') }}
                        </label>

                    </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                    <div class="custom-control custom-checkbox" id="reports_setting-div_full">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="reports_setting_full"
                            name="reports_setting_full"
                            v-model="dedicated.show_statement_report_to_user"
                        >
                        <label class="custom-control-label" id="reports_setting_label_full" for="reports_setting_full">
                            {{ $t('label.showStatementReportToUser') }}
                        </label>

                    </div>
                </kt-row>
                <kt-form-select
                        size="6"
                        id="status"
                        name="status"
                        class="py-2"
                        v-model="dedicated.status"
                >
                    <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses"
                            v-bind:value="status.value"
                            :selected="dedicated.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>
            <transition name="fade">
                <kt-form-group v-if="dedicated.status == 3">
                    <kt-form-label>
                        {{ $t('label.rejection_reason') }}
                    </kt-form-label>
                    <kt-form-control
                            id="rejection_reason"
                            name="rejection_reason"
                            v-model="dedicated.rejection_reason"
                    >
                    </kt-form-control>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <psp-form
                        v-if="
                        dedicated.status == 9
                        || dedicated.status == 1
                        || dedicated.status == 4
                        || dedicated.status == 10"

                        :gate_status="dedicated.status"
                />
            </transition>
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_wage_type') }}
                </kt-form-label>
                <kt-form-select size="3" id="wage_type" name="wage_type" v-model="dedicated.wage_type">
                    <option
                            v-bind:key="index"
                            v-for="(wage_type, index) in wage_types"
                            v-bind:value="wage_type.value"
                            :selected="wage_type.value"
                    >
                        {{ wage_type.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <disabled-input
                    v-if="dedicated.psp"
                    :title="$t('label.psp')"
                    :val="find_psp"
                    idf="psp"
            ></disabled-input>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                            type="checkbox"
                            class="custom-control-input"
                            id="server_ip_limitation"
                            name="server_ip_limitation"
                            v-model="dedicated.server_ip_limitation"
                    >
                    <label class="custom-control-label" for="server_ip_limitation">{{ $t('label.server_ip_limitation') }}</label>
                </div>
            </kt-form-group>
            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                            type="checkbox"
                            class="custom-control-input"
                            id="callback_address_limitation"
                            name="callback_address_limitation"
                            v-model="dedicated.callback_address_limitation"
                    >
                    <label class="custom-control-label" for="callback_address_limitation">{{ $t('label.callback_address_limitation') }}</label>
                </div>
            </kt-form-group>
            <transition name="fade">
                <kt-form-group v-if="dedicated.wage_type == 1">
                    <kt-form-label>
                        {{ $t('label.change_wage_period') }}
                    </kt-form-label>
                    <kt-form-select
                            size="4"
                            id="wage_periodic_type"
                            name="wage_periodic_type"
                            v-model="dedicated.wage_periodic_type"
                    >
                        <option
                                v-bind:key="index"
                                v-for="(wage_periodic_type, index) in wage_periodic_types"
                                v-bind:value="wage_periodic_type.value"
                                :selected="wage_periodic_type.value"
                        >
                            {{ wage_periodic_type.name }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group>
                    <kt-form-label>
                        {{
                        (dedicated.wage_type == 3) ?
                        $t('label.wage_amount_percent') :
                        ((dedicated.wage_type == 2) ?
                        $t('label.wage_amount_fixed') :
                        $t('label.wage_amount_periodic'))
                        }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_amount" name="wage_amount" v-model="dedicated.wage_amount">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{
                                (dedicated.wage_type == 3) ?
                                $t('label.percent'):
                                $t('currency.rial')
                                }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group v-if="dedicated.wage_type == 3">
                    <kt-form-label>
                        {{ $t('label.max_wage_amount') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage" v-model="dedicated.wage_max_wage">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_status_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
        <form  v-if="dedicated.status == dedicatedStatus.SEND_TO_PSP ||
                    dedicated.status == dedicatedStatus.REJECTED_BY_PSP ||
                    dedicated.status == dedicatedStatus.ACTIVE"
               @submit.prevent="submitPSPForm($event, psp_request)"
              id="psp_request_form">
            <div class="container mt-5 p-3 pt-5 my-4 border in-border-header" id="psp_request_container">
                <kt-form-section>
                    <div class="section-header">
                        {{ $t('label.psp_request_data') }}
                    </div>
                    <novin
                            v-if="dedicated.psp === 'novin'"
                            :psp_request="psp_request"
                    ></novin>
                    <sepehr
                        v-if="dedicated.psp === 'sepehr'"
                        :psp_request="psp_request"
                    ></sepehr>
                    <pasargad
                            v-else-if="dedicated.psp === 'pasargad'"
                            :psp_request="psp_request"
                    ></pasargad>
                    <mellat
                            v-else-if="dedicated.psp === 'mellat'"
                            :psp_request="psp_request"
                    ></mellat>
                    <parsian
                            v-else-if="dedicated.psp === 'parsian'"
                            :psp_request="psp_request"
                    ></parsian>
                    <saman
                            v-else-if="dedicated.psp === 'saman'"
                            :psp_request="psp_request"
                    ></saman>
                </kt-form-section>
                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_psp_request">
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </div>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { dedicatedStatusStr, dedicatedStatus } from '@/constants/dedicatedStatus'
import pspSelectModal from './psp-select-modal'
import { dedicatedService } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import pspFrom from './psp-form'
import { disabledInput } from './pspDataComponents'
import { novin, parsian, pasargad, saman, mellat,sepehr } from './psp_request_forms'
import {mapGetters} from "vuex";
import {gatewayService} from '@/common/api.service'

export default {
    components: {
        'psp-form': pspFrom,
        'psp-select-modal': pspSelectModal,
        disabledInput,
        'novin': novin,
        'saman': saman,
        'pasargad': pasargad,
        'mellat': mellat,
        'parsian': parsian,
        'sepehr' : sepehr,
    },
    props: {
        dedicated: {
            required: true,
        },
        status: {
            required: true,
        },
    },
    computed: {
        find_psp(){
            return i18n.t('psp_list.' + this.dedicated.psp)
        },
        ...mapGetters('dedicated', [
            'psp_request'
        ]),
    },
    data() {
        return {
            dedicatedStatus: dedicatedStatus,
            statuses: [
                {
                    name: dedicatedStatusStr.ACTIVE,
                    value: dedicatedStatus.ACTIVE
                },
                {
                    name: dedicatedStatusStr.PENDING,
                    value: dedicatedStatus.PENDING
                },
                {
                    name: dedicatedStatusStr.REJECTED,
                    value: dedicatedStatus.REJECTED
                },
                {
                    name: dedicatedStatusStr.BLOCKED,
                    value: dedicatedStatus.BLOCKED
                },
                {
                    name: dedicatedStatusStr.SEND_TO_PSP,
                    value: dedicatedStatus.SEND_TO_PSP
                },
                {
                    name: dedicatedStatusStr.REJECTED_BY_PSP,
                    value: dedicatedStatus.REJECTED_BY_PSP
                },
            ],
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 2
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 1,
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ],
        }
    },
    methods: {
        edit(e) {
            let btn = $('#change_status_btn')
            let form = $('#settings_form')
            KTApp.progress(btn)
            let is_failed = false
            dedicatedService.changeSettings(this.dedicated.id, {
                wage_type: this.dedicated.wage_type,
                wage_periodic_type: this.dedicated.wage_periodic_type,
                wage_amount: this.dedicated.wage_amount,
                wage_max_wage: this.dedicated.wage_max_wage,
                status: this.dedicated.status,
                rejection_reason: this.dedicated.rejection_reason,
                server_ip_limitation: this.dedicated.server_ip_limitation,
                callback_address_limitation: this.dedicated.callback_address_limitation,
            })
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })
                .finally(
                    response => {
                        KTApp.unprogress(btn)
                    }
                )
            gatewayService.showStatementForCommonUser(this.dedicated.id, this.dedicated.show_statement_report_to_user,'dedicated')
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })
            gatewayService.showPspForCommonUser(this.dedicated.id, this.dedicated.show_psp_report_to_user,'dedicated')
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })
            if (is_failed) {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            } else {
                this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
            }
        },
        submitPSPForm(e, psp_request) {
            let btn = $('#submit_psp_request')
            let form = $(e.target)
            let container = $('#psp_request_container')
            KTApp.progress(btn)

            let port_config = psp_request.port_config
            psp_request.port_config = JSON.stringify(psp_request.port_config);

            dedicatedService.setPSPRequest(this.dedicated.id, psp_request).then(response => {
                this.$store.dispatch('badgeCounter/countData')
                this.showMsg(container, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(container, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
                this.psp_request.port_config = port_config
            })
        }
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>